module.exports = __webpack_public_path__ + "static/decisioningos-thumbnail-33199dc2c7d95bf4422364ca3ec4d54e.jpg";